document.addEventListener('DOMContentLoaded', function () {
  let swiper = new Swiper('.b2b-review .swiper', {
    slidesPerView: 'auto',
    spaceBetween: 16,
    on: {
      init(swiper) {
        if (window.innerWidth >= 1024) return;

        const paginationEl = document.querySelector(
          '.b2b-review .swiper-pagination'
        );

        paginationEl.innerHTML = `<span class="pagination-indicator tw-absolute tw-left-0 tw-h-full tw-rounded-x10  tw-bg-[#2C211E]"></span>`;

        paginationEl.querySelector('.pagination-indicator').style.width =
          `${100 / swiper.slides.length}%`;
      },
      slideChange(swiper) {
        if (window.innerWidth >= 1024) return;

        const bulletWidth = 100 / swiper.slides.length;
        document.querySelector('.b2b-review .pagination-indicator').style.left =
          `${swiper.activeIndex * bulletWidth}%`;
      }
    },
    breakpoints: {
      1024: {
        slidesPerGroupAuto: true,
        centeredSlides: false,
        spaceBetween: 16,
        navigation: {
          nextEl: '.b2b-review .swiper-button-next',
          prevEl: '.b2b-review .swiper-button-prev'
        },
        pagination: {}
      }
    }
  });

  swiper.on('slideChange', swiper => {
    calculateScrollPercentage(swiper, `.b2b-review .tw-h3-b2b`);
  });
});

document.querySelectorAll('quantity-input').forEach(wrapper => {
  const input = wrapper.querySelector('.quantity__input');
  const minus = wrapper.querySelector('[name="minus"]');

  const updateMinus = () => {
    const step = parseFloat(input.getAttribute('step')) || 1;
    const minVal = parseFloat(input.getAttribute('min')) || step;
    const atMin = parseFloat(input.value) <= minVal;
    minus.toggleAttribute('disabled', atMin);
  };

  updateMinus();
  input.addEventListener('input', updateMinus);
  input.addEventListener('change', updateMinus);
});
